import React from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';

const Main = styled.main`
  min-height: 100vh;
  padding-top: 80px; /* Header height */
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  flex: 1;
`;

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <Main>
        <Content>{children}</Content>
        <Footer />
      </Main>
    </>
  );
};

export default Layout;
